const initialize = () => {
    const modalStop = document.getElementById('subscriptionStopModal'),
        listStop = document.querySelectorAll('.subscription-link-stop'),
        stopField = modalStop.querySelectorAll('#subscriptionInputModal')[0],
        modalRenew = document.getElementById('subscriptionRenewModal'),
        listRenew = document.querySelectorAll('.subscription-link-renew'),
        renewField = modalRenew.querySelectorAll('#subscriptionRenewInputModal')[0]
    ;

    listStop.forEach(function (link) {
        link.addEventListener('click', (event) => {
            stopField.value = link.getAttribute('data-id');
        });
    });

    listRenew.forEach(function (link) {
        link.addEventListener('click', (event) => {
            renewField.value = link.getAttribute('data-id');
        });
    });

    const onCompanySelect = (selectedRadio) => {
        console.log(selectedRadio);

        return true;
    }

    var radios = document.querySelectorAll('input[type=radio][name="id"]');
    radios.forEach(radio => radio.addEventListener('change', onCompanySelect(radio)));
};
export default initialize;
